// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

export const triggerDownload = (url: string) => {
	const a = document.createElement("a");
	a.href = url;
	a.download = "";
	a.rel = "noopener";
	document.body.appendChild(a);
	a.click();
	a.remove();
};
